module.exports = __webpack_public_path__ + "img/1-1.010e08c0.svg";